"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateContent = exports.listHeader = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const dayjs_1 = __importDefault(require("dayjs"));
const _NIP = 'NIP';
const _START_DATE = 'Start date Contract(YYYYMMDD)';
const _END_DATE = 'End date Contract(YYYYMMDD)';
const _USERNAME = 'Username';
const _PHASE = 'Phase';
const _PENGETAHUAN_JABATAN_SCORE = 'score_factor::pengetahuan_jabatan::score';
const _PENGETAHUAN_JABATAN_COMMENT = 'score_factor::pengetahuan_jabatan::comment';
const _KUALITAS_KUANTITAS_SCORE = 'score_factor::kualitas_&_kuantitas_kerja::score';
const _KUALITAS_KUANTITAS_COMMENT = 'score_factor::kualitas_&_kuantitas_kerja::comment';
const _LAYANAN_NASABAH_SCORE = 'score_factor::layanan_nasabah::score';
const _LAYANAN_NASABAH_COMMENT = 'score_factor::layanan_nasabah::comment';
const _KERJASAMA_SCORE = 'score_factor::kerja_sama::score';
const _KERJASAMA_COMMENT = 'score_factor::kerja_sama::comment';
const _KOMUNIKASI_SCORE = 'score_factor::komunikasi::score';
const _KOMUNIKASI_COMMENT = 'score_factor::komunikasi::comment';
const _KEMAMPUAN_PRIBADI_SCORE = 'score_factor::kemampuan_pribadi::score';
const _KEMAMPUAN_PRIBADI_COMMENT = 'score_factor::kemampuan_pribadi::comment';
const _MOTIVASI_PRESTASI_SCORE = 'score_factor::motivasi_berprestasi::score';
const _MOTIVASI_PRESTASI_COMMENT = 'score_factor::motivasi_berprestasi::comment';
const _KEMAMPUAN_MANAJERIAL_SCORE = 'score_factor::kemampuan_manajerial::score';
const _KEMAMPUAN_MANAJERIAL_COMMENT = 'score_factor::kemampuan_manajerial::comment';
const _PENGEMBANGAN_DIRI_SCORE = 'score_factor::pengembangan_diri::score';
const _PENGEMBANGAN_DIRI_COMMENT = 'score_factor::pengembangan_diri::comment';
const _INTEGRITAS_SCORE = 'score_factor::integritas::score';
const _INTEGRITAS_COMMENT = 'score_factor::integritas::comment';
const _BONUS_SCORE = 'bonus::bonus::score';
const listHeader = [
    {
        name: _NIP,
        type: 'string',
        requiredLength: 8,
        maxLength: 0,
        required: true,
        fieldQuery: 'nip'
    },
    {
        name: _START_DATE,
        type: 'date',
        requiredLength: 8,
        maxLength: 0,
        required: true,
        fieldQuery: 'start_date'
    },
    {
        name: _END_DATE,
        type: 'date',
        requiredLength: 8,
        maxLength: 0,
        required: true,
        fieldQuery: 'end_date'
    },
    {
        name: _USERNAME,
        type: 'string',
        requiredLength: 0,
        maxLength: 255,
        required: true,
        fieldQuery: 'username'
    },
    {
        name: _PHASE,
        type: 'string',
        requiredLength: 0,
        maxLength: 255,
        required: true,
        fieldQuery: 'phase_type'
    },
    {
        name: _PENGETAHUAN_JABATAN_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _PENGETAHUAN_JABATAN_SCORE
    },
    {
        name: _PENGETAHUAN_JABATAN_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _PENGETAHUAN_JABATAN_COMMENT
    },
    {
        name: _KUALITAS_KUANTITAS_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KUALITAS_KUANTITAS_SCORE
    },
    {
        name: _KUALITAS_KUANTITAS_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KUALITAS_KUANTITAS_COMMENT
    },
    {
        name: _LAYANAN_NASABAH_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _LAYANAN_NASABAH_SCORE
    },
    {
        name: _LAYANAN_NASABAH_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _LAYANAN_NASABAH_COMMENT
    },
    {
        name: _KERJASAMA_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KERJASAMA_SCORE
    },
    {
        name: _KERJASAMA_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KERJASAMA_COMMENT
    },
    {
        name: _KOMUNIKASI_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KOMUNIKASI_SCORE
    },
    {
        name: _KOMUNIKASI_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KOMUNIKASI_COMMENT
    },
    {
        name: _KEMAMPUAN_PRIBADI_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KEMAMPUAN_PRIBADI_SCORE
    },
    {
        name: _KEMAMPUAN_PRIBADI_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KEMAMPUAN_PRIBADI_COMMENT
    },
    {
        name: _MOTIVASI_PRESTASI_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _MOTIVASI_PRESTASI_SCORE
    },
    {
        name: _MOTIVASI_PRESTASI_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _MOTIVASI_PRESTASI_COMMENT
    },
    {
        name: _KEMAMPUAN_MANAJERIAL_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KEMAMPUAN_MANAJERIAL_SCORE
    },
    {
        name: _KEMAMPUAN_MANAJERIAL_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _KEMAMPUAN_MANAJERIAL_COMMENT
    },
    {
        name: _PENGEMBANGAN_DIRI_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _PENGEMBANGAN_DIRI_SCORE
    },
    {
        name: _PENGEMBANGAN_DIRI_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _PENGEMBANGAN_DIRI_COMMENT
    },
    {
        name: _INTEGRITAS_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _INTEGRITAS_SCORE
    },
    {
        name: _INTEGRITAS_COMMENT,
        type: 'string',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _INTEGRITAS_COMMENT
    },
    {
        name: _BONUS_SCORE,
        type: 'score',
        requiredLength: 0,
        maxLength: 0,
        required: false,
        fieldQuery: _BONUS_SCORE
    }
];
exports.listHeader = listHeader;
const validateContent = async (data, setError) => {
    const setFlag = (error) => {
        setError && setError(error);
        return false;
    };
    let flag = true;
    const incomingData = [...data.data];
    const fields = [...data.meta.fields];
    const parsedBody = [];
    fields.forEach((field) => {
        const availHeader = listHeader.map((header) => header.name);
        if (!availHeader.includes(field)) {
            flag = setFlag(`Header name '${field}' is incorrect`);
            return;
        }
    });
    flag &&
        incomingData.forEach((key, index) => {
            const row = index + 1;
            let answer = {};
            const haveAllKey = listHeader.every((header) => Object.prototype.hasOwnProperty.call(key, header.name));
            if (!haveAllKey) {
                delete incomingData[index];
                flag = setFlag(`Invalid csv header`);
                return;
            }
            listHeader.some((header) => {
                const isRequired = header.required;
                const type = header.type;
                const requiredLength = header.requiredLength;
                const maxLength = header.maxLength;
                const columnName = header.name;
                if (isRequired && (!key[columnName] || key[columnName] == '')) {
                    flag = setFlag(`${columnName} is required at row ${row}`);
                    return { flag, incomingData };
                }
                const errorMessage = `${columnName} is Invalid at row ${row}`;
                if ((type == 'date' &&
                    !(0, dayjs_1.default)(key[columnName], 'YYYYMMDD', true).isValid()) ||
                    (requiredLength > 0 && key[columnName].length != requiredLength) ||
                    (maxLength > 0 && key[columnName].length > maxLength)) {
                    flag = setFlag(errorMessage);
                    return { flag, incomingData };
                }
                let value = key[header.name];
                if (type == 'score' &&
                    (value || value != '') &&
                    isNaN(parseFloat(value))) {
                    flag = setFlag(errorMessage);
                    return { flag, incomingData };
                }
                if (type != 'score' && (!value || value == '')) {
                    value = null;
                }
                if (type == 'score' && (value || value != '')) {
                    value = parseFloat(value);
                }
                if (columnName == _PHASE) {
                    value = 'manager_review';
                }
                answer = { ...answer, [header.fieldQuery]: value };
            });
            if (!flag)
                return;
            parsedBody.push(answer);
        });
    return { flag, parsedBody: { answers: parsedBody } };
};
exports.validateContent = validateContent;
